import * as React from "react";
import moment from "moment-timezone";
import classnames from "classnames";
import { User32 } from "@carbon/icons-react";

import DocumentLink from "web_modules/underwriter_dashboard/DocumentViewer/DocumentLink";

const FontAwesome = require("react-fontawesome");
const VisibilitySensor = require("react-visibility-sensor");

const styles = require("./styles.module.scss");

interface MessageDisplayProps {
  appID: number;
  message: any;
  markRead?: Function;
}

class MessageDisplay extends React.Component<MessageDisplayProps, any> {
  constructor(props: MessageDisplayProps) {
    super(props);

    this.state = {};
    this.componentVisibilityChanged = this.componentVisibilityChanged.bind(this);
    this.markRead = this.markRead.bind(this);
  }

  markRead() {
    this.props.markRead(this.props.message.id);
  }

  componentIsVisible() {
    if (!this.props.message.read_by_operator || !this.props.message.read) {
      this.setState({ timeoutID: window.setTimeout(this.markRead, 1000) });
    }
  }

  componentVisibilityChanged(visible) {
    if (visible && !this.state.timeoutID) {
      this.componentIsVisible();
    }
  }

  render() {
    const { message, appID } = this.props;

    return (
      <li className={styles.messageContainer}>
        <div className={classnames(styles.message, styles[message.sender_type])}>
          <span className={styles.messageContent}>{message.message}</span>
          <span className={classnames(styles.arrow, styles[message.sender_type])} />
          <VisibilitySensor onChange={this.componentVisibilityChanged}>
            <span
              className={classnames(styles.photo, styles[message.sender_type], {
                [styles.read]: message.read_by_operator,
              })}
            >
              <User32 />
            </span>
          </VisibilitySensor>
        </div>
        <div className={classnames(styles.extra, styles[message.sender_type])}>
          <div className={styles.timesentWrapper}>
            <time dateTime={moment(message.created_at).format()}>
              {moment(message.created_at).tz(moment.tz.guess()).format("MM/DD/YYYY h:mm A zz")}
            </time>

            {/* `sender_name` comes from back-end so isn't immediately available upon initial send; instead of optimistic loading, just hide for initially-sent messages since sender is implicitly known */}
            {message.sender_name && <span> by {message.sender_name}</span>}
          </div>
          {message.is_noia_message && (
            <div className={styles.noia_container}>
              <p className={styles.noia_subscript}>
                Notice of Incomplete Application (NOIA) included in message. NOIA Date:{" "}
                {moment(message.created_at).format("MM/DD/YYYY")}
              </p>
            </div>
          )}
          {message.documents && (
            <ul>
              {message.documents.map((doc, i) => (
                <li key={i}>
                  <DocumentLink appId={appID} docId={doc.id}>
                    {doc.revised_filename
                      ? `View ${doc.revised_filename} (formerly: ${doc.original_filename})`
                      : `View ${doc.original_filename}`}
                  </DocumentLink>{" "}
                  –{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`/underwriter/app/${doc.loan_application_id}/DocumentsHurdle?d=${doc.id}`}
                  >
                    View in DocumentsHurdle
                  </a>
                </li>
              ))}
            </ul>
          )}
          {this.props.children}
        </div>
      </li>
    );
  }
}

export default MessageDisplay;
